import { useState } from "react";
import moment from "moment";
import { useI18n, useComponentWillMount } from "Hooks";
import { useMount } from "Utils/CustomHooks";

const useLockingTimer = ({ scheduledAt, onTimerStopCallback }) => {
  const scheduledTime = moment.utc(scheduledAt);

  const [minutes, setMinutes] = useState(
    scheduledTime.diff(moment(), "minutes")
  );
  const [seconds, setSeconds] = useState(
    scheduledTime.diff(moment(), "seconds")
  );

  const { t } = useI18n(["common"]);

  const lockingTimer =
    seconds >= 60
      ? t("minutes_count", {
          count: minutes + 1,
        })
      : t("seconds_count", {
          count: seconds,
        });

  useMount(() => {
    const interval = setInterval(() => {
      const timeSeconds = scheduledTime.diff(moment(), "seconds");

      const timeMinutes = scheduledTime.diff(moment(), "minutes");

      if (timeSeconds <= 0) {
        onTimerStopCallback();
        clearInterval(interval);
      }

      setMinutes(timeMinutes);
      setSeconds(timeSeconds);
    }, 1000);

    return () => clearInterval(interval);
  });

  useComponentWillMount(() => {
    const timeSeconds = scheduledTime.diff(moment(), "seconds");

    if (timeSeconds <= 0) {
      onTimerStopCallback();
    }
  });
  return { lockingTimer, seconds };
};
export default useLockingTimer;
